// extracted by css-extract-rspack-plugin
export default {"avatarStack":"AssigneesMetadata-module__avatarStack__HpIYpRS","avatar":"AssigneesMetadata-module__avatar__NGgwkRL"};